module.exports = __webpack_public_path__ + "media/images/icon-1-a1da3c289fa00636a6bd80dd0260c027.svg";